import { Roles } from '../enums/roles.enum';
import { ROUTES } from './routes';

export const MENU = {
  [Roles.SUPER_ADMIN]: [
    { icon: 'PagesAdd', path: ROUTES.APPLICATIONS.ROOT, key: 'applications', label: 'Заявки' },
    { icon: 'Office', path: ROUTES.CHECKING, key: 'checking', label: 'Checking' },
    { icon: 'Users', path: ROUTES.USERS, key: 'users', label: 'Пользователи' },
    {
      icon: 'PageStar',
      path: ROUTES.CERTIFICATES,
      key: 'certificates',
      label: 'Cертификаты',
    },
    // { icon: 'Office', path: ROUTES.ORGANIZATIONS, key: 'organizations', label: 'Организации' },
    // { icon: 'PageStar', path: ROUTES.DIRECTIONS, key: 'directions', label: 'Направления' },
    // { icon: 'Map', path: ROUTES.REGIONS, key: 'regions', label: 'Регионы' },
    // { icon: 'District', path: ROUTES.DISTRICTS, key: 'districts', label: 'Районы' },
    // { icon: 'Location', path: ROUTES.LOCATIONS, key: 'locations', label: 'Офисы' },
    // { icon: 'GridAdd', path: ROUTES.SCHEDULES, key: 'schedules', label: 'Графики' },
    // { icon: 'List', path: ROUTES.TESTS, key: 'tests', label: 'Тесты' },
    // { icon: 'Warning', path: ROUTES.APPEALS.ROOT, key: 'appeals', label: 'Апелляции' },
    {
      icon: 'References',
      path: ROUTES.REFERENCES.DIRECTIONS,
      key: 'references',
      label: 'Справочники',
    },
    { icon: 'Reports', path: ROUTES.REPORTS, key: 'reports', label: 'Отчеты' },
    // {
    //   icon: 'NotificationsPage',
    //   path: ROUTES.NOTIFICATIONS,
    //   key: 'notifications',
    //   label: 'Уведомления',
    // },
  ],
  [Roles.ORGANIZATION_ADMIN]: [
    { icon: 'PagesAdd', path: ROUTES.APPLICATIONS.ROOT, key: 'applications', label: 'Заявки' },
    // { icon: 'Users', path: ROUTES.USERS, key: 'users', label: 'Пользователи' },
    // { icon: 'Location', path: ROUTES.LOCATIONS, key: 'locations', label: 'Офисы' },
    // { icon: 'GridAdd', path: ROUTES.SCHEDULES, key: 'schedules', label: 'Графики' },
    // { icon: 'List', path: ROUTES.TESTS, key: 'tests', label: 'Тесты' },
    // { icon: 'Warning', path: ROUTES.APPEALS.ROOT, key: 'appeals', label: 'Апелляции' },
    // {
    //   icon: 'NotificationsPage',
    //   path: ROUTES.NOTIFICATIONS,
    //   key: 'notifications',
    //   label: 'Уведомления',
    // },
  ],
  [Roles.CENTRAL_ADMIN]: [
    { icon: 'PagesAdd', path: ROUTES.APPLICATIONS.ROOT, key: 'applications', label: 'Заявки' },
    { icon: 'Office', path: ROUTES.CHECKING, key: 'checking', label: 'Checking' },
    // {
    //   icon: 'OutlineAccount',
    //   path: ROUTES.CABINET,
    //   key: 'personalCabinet',
    //   label: 'Личный кабинет',
    // },
    // { icon: 'List', path: ROUTES.ATTESTATION, key: 'testing', label: 'Тестирование' },
  ],
  [Roles.REGION_ADMIN]: [
    {
      icon: 'OutlineAccount',
      path: ROUTES.CABINET,
      key: 'personalCabinet',
      label: 'Личный кабинет',
    },
    {
      icon: 'PagesAdd',
      path: ROUTES.APPLICATIONS.ROOT,
      key: 'myApplications',
      label: 'Мои заявки',
    },
    { icon: 'Office', path: ROUTES.CHECKING, key: 'checking', label: 'Checking' },
    {
      icon: 'PageStar',
      path: ROUTES.CERTIFICATES,
      key: 'myCertificates',
      label: 'Мои сертификаты',
    },
  ],
  DEFAULT: [
    {
      icon: 'OutlineAccount',
      path: ROUTES.CABINET,
      key: 'personalCabinet',
      label: 'Личный кабинет',
    },
    {
      icon: 'PagesAdd',
      path: ROUTES.APPLICATIONS.ROOT,
      key: 'myApplications',
      label: 'Мои заявки',
    },
    // { icon: 'List', path: ROUTES.TEST.ROOT, key: 'testing', label: 'Тестирование' },
    {
      icon: 'PageStar',
      path: ROUTES.CERTIFICATES,
      key: 'myCertificates',
      label: 'Мои сертификаты',
    },
    // { icon: 'Warning', path: ROUTES.APPEALS.ROOT, key: 'appeals', label: 'Апелляция' },
    // {
    //   icon: 'NotificationsPage',
    //   path: ROUTES.NOTIFICATIONS,
    //   key: 'notifications',
    //   label: 'Уведомления',
    // },
  ],
};
